/* Juana Pilar — tablas de talles por producto (handle). Medidas de la prenda en pulgadas, de la tabla del proveedor. Editar aquí cuando lleguen las muestras. */
window.JP_SIZE_CHARTS = {
  "_nota": "Medidas de la prenda en pulgadas, sacadas de la tabla del proveedor en AliExpress (vista EE.UU., 2026-10-17). 'us' = equivalencia de talle EE.UU. que da el proveedor. Si no hay medidas de la prenda, el buscador usa las medidas estándar del talle US. Verificar con la muestra.",
  "petite-knit-wide-leg-pants": {
    "kind": "bottoms", "fabric": "stretch", "fitStyle": "Relaxed wide leg",
    "source": "Measured by the supplier",
    "sizes": [
      { "size": "S", "us": "4", "waist": 22.83, "hip": 38.19, "length": 38.58 },
      { "size": "M", "us": "6", "waist": 23.23, "hip": 38.58, "length": 38.98 },
      { "size": "L", "us": "8-10", "waist": 23.62, "hip": 39.37, "length": 39.37 },
      { "size": "XL", "us": "12", "waist": 24.41, "hip": 40.16, "length": 39.76 },
      { "size": "XXL", "us": "14", "waist": 25.20, "hip": 40.94, "length": 40.16 }
    ]
  },
  "petite-straight-trousers-green": {
    "kind": "bottoms", "fabric": "woven", "fitStyle": "Tailored straight leg",
    "source": "Measured by the supplier",
    "sizes": [
      { "size": "XS", "us": "2", "waist": 25.20, "hip": 35.43, "length": 38.78 },
      { "size": "S", "us": "4", "waist": 26.77, "hip": 37.01, "length": 39.17 },
      { "size": "M", "us": "6", "waist": 28.35, "hip": 38.58, "length": 39.57 },
      { "size": "L", "us": "8", "waist": 29.92, "hip": 40.16, "length": 39.96 },
      { "size": "XL", "us": "10-12", "waist": 32.28, "hip": 42.52, "length": 40.55 }
    ]
  },
  "striped-polo-sweater-pink-brown": {
    "kind": "tops", "fabric": "knit", "fitStyle": "Oversized, slightly cropped",
    "source": "Measured by the supplier",
    "sizes": [
      { "size": "S", "us": "4", "bust": 47.24, "length": 21.26, "sleeve": 18.50 },
      { "size": "M", "us": "6", "bust": 48.03, "length": 21.65, "sleeve": 18.90 },
      { "size": "L", "us": "8-10", "bust": 48.82, "length": 22.05, "sleeve": 19.29 }
    ]
  },
  "off-shoulder-bow-sweater-cream": {
    "kind": "tops", "fabric": "knit", "fitStyle": "Fitted",
    "source": "Measured by the supplier",
    "sizes": [
      { "size": "XS", "us": "2" },
      { "size": "S", "us": "4", "bust": 31.50, "length": 21.65, "sleeve": 20.08 },
      { "size": "M", "us": "6", "bust": 33.07, "length": 22.05, "sleeve": 20.47 },
      { "size": "L", "us": "8-10", "bust": 33.86, "length": 22.44, "sleeve": 20.87 }
    ]
  },
  "short-sleeve-knit-cardigan-pink": {
    "kind": "tops", "fabric": "knit", "fitStyle": "Cropped boxy",
    "source": "Based on standard US sizing",
    "sizes": [ { "size": "S", "us": "4" }, { "size": "M", "us": "6" }, { "size": "L", "us": "8-10" } ]
  },
  "petite-peacoat-black": {
    "kind": "outerwear", "fabric": "woven", "fitStyle": "Fitted waist, flared hem",
    "source": "Based on standard US sizing",
    "sizes": [ { "size": "S", "us": "4" }, { "size": "M", "us": "6" }, { "size": "L", "us": "8-10" } ]
  },
  "heart-button-cardigan-cream": { "kind": "onesize", "fitStyle": "Regular, slightly cropped" },
  "bow-striped-cardigan-pink": { "kind": "onesize", "fitStyle": "Oversized" }
};
window.JP_SIZE_CHARTS["petite-wide-leg-jeans-washed-black"] = { "kind": "bottoms", "fabric": "woven", "fitStyle": "Relaxed wide leg", "source": "Measured by the supplier",
  "sizes": [ { "size": "S", "us": "4", "length": 39.0 }, { "size": "M", "us": "6", "length": 39.4 }, { "size": "L", "us": "8-10" }, { "size": "XL", "us": "12" } ] };
window.JP_SIZE_CHARTS["petite-straight-jeans-light-blue"] = { "kind": "bottoms", "fabric": "woven", "fitStyle": "Relaxed straight leg", "source": "Measured by the supplier",
  "sizes": [ { "size": "S", "us": "4", "length": 38.6 }, { "size": "M", "us": "6", "length": 39.0 }, { "size": "L", "us": "8-10" }, { "size": "XL", "us": "12" } ] };
window.JP_SIZE_CHARTS["petite-merino-knit-wide-leg-pants-mocha"] = { "kind": "bottoms", "fabric": "stretch", "fitStyle": "Fluid wide leg, waist runs small (size up)", "source": "Measured by the supplier",
  "sizes": [ { "size": "S", "us": "2", "length": 35.4 }, { "size": "M", "us": "4", "length": 36.2 }, { "size": "L", "us": "6" }, { "size": "XL", "us": "8-10" } ] };